var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeftDecoration = function SvgLeftDecoration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 70 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.02 77.306c-1.679-6.556-5.619-9.925-12.206-11.825 6.652-1.593 10.333-5.33 12.27-11.825 1.81 6.31 5.49 9.987 12.143 11.703-6.265 2.144-10.14 5.759-12.207 11.947ZM11.807 21.563c-1.487-5.977-4.976-9.05-10.81-10.781C6.888 9.329 10.148 5.922 11.864 0c1.602 5.754 4.862 9.106 10.753 10.67-5.548 1.955-8.98 5.251-10.81 10.893Z",
    fill: "#CDF2C7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 51.262,
    cy: 36.067,
    r: 17.535,
    fill: "#53B741"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.45,
    cy: 32.086,
    r: 17.535,
    fill: "#9CE58F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.106 26.134c-1.111.221-1.99.675-2.638 1.361-.387.407-.704.938-.952 1.593-.25.675-.355 1.291-.313 1.847l6.768-1.347-.003 1.383-6.66 1.325a22.847 22.847 0 0 0 .26 1.31l6.392-1.272-.013 1.385-5.905 1.176c.58 1.46 1.462 2.402 2.647 2.826a4.81 4.81 0 0 0 2.607.193c1.238-.246 2.14-.763 2.705-1.55l.407 2.045c-.751.548-1.626.922-2.625 1.12-2.99.596-5.26-.245-6.806-2.524-.312-.46-.615-1.033-.91-1.717l-1.518.302.013-1.385 1.042-.207a12.989 12.989 0 0 1-.28-1.306l-1.3.258.013-1.385 1.15-.23c-.018-2.238.742-3.998 2.282-5.282.95-.794 2.066-1.319 3.35-1.574 1.23-.245 2.319-.183 3.265.185l-.03 1.925c-.94-.507-1.922-.66-2.948-.455Z",
    fill: "#53B741"
  }))));
};
export default SvgLeftDecoration;